import React from "react";
import logo from "../../Images/UEL Logo Blackpercent.jpg";

function LogoBar() {
  return (
    <div>
      <img src={logo} alt="UEL Logo" className="logoStyle"></img>
    </div>
  );
}

export default LogoBar;
